import { render } from "./sellLogixLoader.vue?vue&type=template&id=f962de3e"
import script from "./sellLogixLoader.vue?vue&type=script&lang=js"
export * from "./sellLogixLoader.vue?vue&type=script&lang=js"

import "./sellLogixLoader.vue?vue&type=style&index=0&id=f962de3e&lang=css"

import exportComponent from "/var/www/public_web/selllogix-vuecli/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__